import * as React from 'react';
import { DefaultPalette, ICommandBarItemProps } from '@fluentui/react';
import TimeTaxSupportSystemClient from '../../system';
import { DateTime } from 'luxon';
import MessageCourier from '../../lib/MessageCourier';
import ViewWrapperWithCommandBar from '../Layout/ViewWrapperWithCommandBar';
import { defaultCommandBarButtonStyles, titleCommandBarButtonStyles } from '../../styles/button-styles';
import { ReportingFilters } from './ReportingFilters';
import {
  IReporteGralHoras,
  IReporteHorasCumplimientoGeneral,
  IReporteHorasCumplimientoIndividual,
} from '../../system/reporting/ReportingSystem';
import { useTranslation } from 'react-i18next';
import TabPanel, { Item } from 'devextreme-react/tab-panel';

import { User } from '../../system/User';
import { ReportHoursSectorDetail } from './HoursSector/ReportHoursSectorDetail';
import { ReportHoursSectorCumplimientoIndividual } from './HoursSector/ReportHoursSectorCumplimientoIndividual';
import { ReportHoursSectorCumplimientoGeneral } from './HoursSector/ReportHoursSectorCumplimientoGeneral';
import useIsMobile from '../../common/custom-hooks/useIsMobile';
import { IorganizationLevels } from '../../system/AuthenticationSystem';
import Loading from '../Spinners/Loading';
import { ReportHoursSectorCumplimientoUnificado } from './HoursSector/ReportHoursSectorCumplimientoUnificado';

interface IReportingSettlementHoursSector {
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  changeBlockUI: (state: boolean) => void;
  user: User;
}

export const ReportingSettlementHoursSectorDE = (props: IReportingSettlementHoursSector) => {
  const { t } = useTranslation();
  const [nodeId, setNodeId] = React.useState<string>('');
  const [reset, setReset] = React.useState<boolean>(true);
  const [from, setFrom] = React.useState<DateTime | undefined>(undefined);
  const [to, setTo] = React.useState<DateTime | undefined>(undefined);
  const [items, setItems] = React.useState<IReporteGralHoras[]>([]);
  const [levelsN, setLevelsN] = React.useState<IorganizationLevels[]>([]);
  const [itemsCumplimientoIndividual, setItemsCumplimientoIndividual] = React.useState<
      IReporteHorasCumplimientoIndividual[]
  >([]);
    const [loading, setLoading] = React.useState<boolean>(true);

  const [itemsCumplimientoGeneral, setItemsCumplimientoGeneral] = React.useState<
      IReporteHorasCumplimientoGeneral[]
  >([]);
  const [itemsCumplimientoGeneralV2, setItemsCumplimientoGeneralV2] = React.useState<
      IReporteHorasCumplimientoGeneral[]
  >([]);
  const [itemsCumplimientoIndividualV2, setItemsCumplimientoIndividualV2] = React.useState<
      IReporteHorasCumplimientoIndividual[]
  >([]);
  
  const { isMobile } = useIsMobile();

/*   const load = async ()=>{
    try {
      await props.system.getCompanySystem().getList();
      setLoading(false);
    } catch (error) {
      setLoading(true);
    }
  } */

  const itemsMenu = React.useMemo(
      (): ICommandBarItemProps[] => [
        {
          key: 'title',
          text: t('Reporte de horas por sector'),
          iconProps: {
            iconName: 'ReminderPerson',
            color: DefaultPalette.themeLighterAlt,
            className: 'text-title-btn',
          },
          buttonStyles: titleCommandBarButtonStyles,
          className: 'text-title-btn',
        },
      ],
      []
  );

  const resetTableAfterExport = () => {
    setReset(false);
    setTimeout(() => {
      setReset(true);
    }, 50);
  };

  const buildHierarchyPath = (item: IReporteGralHoras): string => {
    return levelsN
      .map(level => item[level.nio_nombre_tec])
      .filter(Boolean)
      .join(' > ');
  };

  const mapCumplimientoGral = (_items: IReporteGralHoras[]) => {
    const groupByDireccion = _items.reduce((acc, item) => {
      const nd_vicepresidencia = item[levelsN[0].nio_nombre_tec];
      if (!acc[nd_vicepresidencia]) {
        let pct = parseFloat(((item.horas / item.cant_horas_esperadas) * 100).toFixed(2));

        acc[nd_vicepresidencia] = {
          [levelsN[0].nio_nombre_tec]: nd_vicepresidencia,
          cant_colaboradores: 1,
          horas_cargadas_totales: item.horas,
          horas_esperadas_totales: item.cant_horas_esperadas,
          porcentaje_cumplimiento: pct > 100 ? 100 : pct,
        };
      } else {
        acc[nd_vicepresidencia].cant_colaboradores++;
        acc[nd_vicepresidencia].horas_cargadas_totales += item.horas;
        acc[nd_vicepresidencia].horas_esperadas_totales += item.cant_horas_esperadas;
        let hrsCargadasTotal = acc[nd_vicepresidencia].horas_cargadas_totales;
        let hrsEsperadasTotal = acc[nd_vicepresidencia].horas_esperadas_totales;
        let pct = parseFloat(((hrsCargadasTotal / hrsEsperadasTotal) * 100).toFixed(2));
        acc[nd_vicepresidencia].porcentaje_cumplimiento = pct > 100 ? 100 : pct;
      }
      return acc;
    }, {});

    let result: IReporteHorasCumplimientoGeneral[] = Object.values(groupByDireccion);
    setItemsCumplimientoGeneral(result);
  };

  const mapCumplimientoIndividual = (_items: IReporteGralHoras[]) => {
    const groupByDireccion = _items.reduce((acc, item) => {
      const nd_vicepresidencia = item[levelsN[0].nio_nombre_tec];
      if (!acc[nd_vicepresidencia]) {
        acc[nd_vicepresidencia] = {
          [ levelsN[0].nio_nombre_tec]: nd_vicepresidencia,
          cant_colaboradores: 1,
          cant_colaboradores_horas_completas: +(item.horas >= item.cant_horas_esperadas),
          cant_colaboradores_horas_incompletas: +(item.horas < item.cant_horas_esperadas),
          porcentaje_cumplimiento: +(item.horas >= item.cant_horas_esperadas) ? 100 : 0,
        };
      } else {
        acc[nd_vicepresidencia].cant_colaboradores++;
        acc[nd_vicepresidencia].cant_colaboradores_horas_completas += +(item.horas >= item.cant_horas_esperadas);
        acc[nd_vicepresidencia].cant_colaboradores_horas_incompletas += +(item.horas < item.cant_horas_esperadas);
        let cantColTotal = acc[nd_vicepresidencia].cant_colaboradores;
        let cantHsCompletas = acc[nd_vicepresidencia].cant_colaboradores_horas_completas;
        let pct = parseFloat(((cantHsCompletas / cantColTotal) * 100).toFixed(2));
        acc[nd_vicepresidencia].porcentaje_cumplimiento = pct > 100 ? 100 : pct;
      }
      return acc;
    }, {});

    let result: IReporteHorasCumplimientoIndividual[] = Object.values(groupByDireccion);
    setItemsCumplimientoIndividual(result);
  };
    

  const mapCumplimientoGralV2 = (_items: IReporteGralHoras[]) => {
    const grouped = _items.reduce((acc, item) => {
      const hierarchyPath = buildHierarchyPath(item);

      if (!acc[hierarchyPath]) {
        acc[hierarchyPath] = {
          hierarchy_path: hierarchyPath,
          cant_colaboradores: 1,
          horas_cargadas_totales: item.horas,
          horas_esperadas_totales: item.cant_horas_esperadas,
          porcentaje_cumplimiento: 0,
        };
      } else {
        acc[hierarchyPath].cant_colaboradores++;
        acc[hierarchyPath].horas_cargadas_totales += item.horas;
        acc[hierarchyPath].horas_esperadas_totales += item.cant_horas_esperadas;
      }

      const cargadas = acc[hierarchyPath].horas_cargadas_totales;
      const esperadas = acc[hierarchyPath].horas_esperadas_totales;
      acc[hierarchyPath].porcentaje_cumplimiento = Math.min(
        100,
        +((cargadas / esperadas) * 100).toFixed(2)
      );

      return acc;
    }, {} as Record<string, IReporteHorasCumplimientoGeneral & { hierarchy_path: string }>);

    setItemsCumplimientoGeneralV2(Object.values(grouped));
  };


  const mapCumplimientoIndividualV2 = (_items: IReporteGralHoras[]) => {
    const grouped = _items.reduce((acc, item) => {
      const hierarchyPath = buildHierarchyPath(item);

      if (!acc[hierarchyPath]) {
        acc[hierarchyPath] = {
          hierarchy_path: hierarchyPath,
          cant_colaboradores: 1,
          cant_colaboradores_horas_completas: +(item.horas >= item.cant_horas_esperadas),
          cant_colaboradores_horas_incompletas: +(item.horas < item.cant_horas_esperadas),
          porcentaje_cumplimiento: 0,
        };
      } else {
        acc[hierarchyPath].cant_colaboradores++;
        acc[hierarchyPath].cant_colaboradores_horas_completas += +(item.horas >= item.cant_horas_esperadas);
        acc[hierarchyPath].cant_colaboradores_horas_incompletas += +(item.horas < item.cant_horas_esperadas);
      }

      const total = acc[hierarchyPath].cant_colaboradores;
      const completas = acc[hierarchyPath].cant_colaboradores_horas_completas;
      acc[hierarchyPath].porcentaje_cumplimiento = Math.min(
        100,
        +((completas / total) * 100).toFixed(2)
      );

      return acc;
    }, {} as Record<string, IReporteHorasCumplimientoIndividual & { hierarchy_path: string }>);

    setItemsCumplimientoIndividualV2(Object.values(grouped));
  };


  const onClickSearch = async () => {
    props.changeBlockUI(true);
    try {
      if (from && to) {
        const _items = await props.system.getReportingSystem().getGralHorasReport(from, to, nodeId);
        setItems(_items);
        mapCumplimientoGral(_items);
        mapCumplimientoIndividual(_items);
        mapCumplimientoGralV2(_items);
        mapCumplimientoIndividualV2(_items);
        props.courier.messageSuccess(t('Reporte generado con éxito'));
      } else {
        props.courier.messageError(t('Debes seleccionar un sector'));
      }
    } catch (error) {
      props.courier.messageError(error);
    }
    props.changeBlockUI(false);
  };

  const levesN = async()=>{
       setLoading(true);
       const levesdata = await props.system.getOrganizationLevels();
       setLevelsN(levesdata);
       setLoading(false);
  }

    React.useEffect(() => {
      /* load(); */
      levesN();
    },[props.system])
  
    if(loading){
      return <Loading title='Cargando' description='Por favor espere estamos procesando la información necesaria para completar su solicitud.'/>
    }

  return (
      <ViewWrapperWithCommandBar
          withBorderBottom
          title={''}
          items={itemsMenu}
          overflowButtonStyles={defaultCommandBarButtonStyles}
          variant="highligth"
          titleBody={t('Reporte de horas por sector')}
      >
        <div className={`padding-1 bg-white`} style={{ paddingTop: 0}}>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <ReportingFilters
                    system={props.system}
                    courier={props.courier}
                    onChangeFromDate={(d) => setFrom(d)}
                    onChangeToDate={(d) => setTo(d)}
                    onChangeCompany={(c) => {}}
                    onChangeNode={(c) => setNodeId(c)}
                    onClickSearch={onClickSearch}
                    showSectorFilter={true}
                    user={props.user}
                />
                {reset && items && items.length > 0 && (
                    <div className="ms-Grid-row mt-2">
                      <div className="ms-Grid-col ms-sm12" style={{ marginBottom: "50px"}}>
                        <TabPanel id="tabPanel" deferRendering={false} className={`${isMobile ? 'container-mobile-title-table' : ''}`}>
                          <Item title={t("Detalle")}>
                            {from && to && (
                                <ReportHoursSectorDetail
                                    system={props.system}
                                    courier={props.courier}
                                    changeBlockUI={props.changeBlockUI}
                                    user={props.user}
                                    items={items}
                                    from={from}
                                    to={to}
                                    resetTableAfterExport={resetTableAfterExport}
                                    levelsN={levelsN}
                                />
                            )}
                          </Item>
                          <Item title={t('Cumplimiento por área')}>
                            {from && to && (
                              <ReportHoursSectorCumplimientoUnificado
                                system={props.system}
                                courier={props.courier}
                                changeBlockUI={props.changeBlockUI}
                                user={props.user}
                                itemsGeneral={itemsCumplimientoGeneralV2}
                                itemsIndividual={itemsCumplimientoIndividualV2}
                                from={from}
                                to={to}
                                resetTableAfterExport={resetTableAfterExport}
                                levelsN={levelsN}
                              />
                            )}
                          </Item>

                          <Item title={t("Cumplimiento general por sector")}>
                            {from && to && (
                                <ReportHoursSectorCumplimientoGeneral
                                    system={props.system}
                                    courier={props.courier}
                                    changeBlockUI={props.changeBlockUI}
                                    user={props.user}
                                    items={itemsCumplimientoGeneral}
                                    from={from}
                                    to={to}
                                    resetTableAfterExport={resetTableAfterExport}
                                    levelsN={levelsN}
                                />
                            )}
                          </Item>
                          <Item title={t("Cumplimiento individual por sector")}>
                            {from && to && (
                                <ReportHoursSectorCumplimientoIndividual
                                    system={props.system}
                                    courier={props.courier}
                                    changeBlockUI={props.changeBlockUI}
                                    user={props.user}
                                    items={itemsCumplimientoIndividual}
                                    from={from}
                                    to={to}
                                    resetTableAfterExport={resetTableAfterExport}
                                    levelsN={levelsN}
                                />
                            )}
                          </Item>
                        </TabPanel>
                      </div>
                    </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </ViewWrapperWithCommandBar>
  );
};
